// extracted by mini-css-extract-plugin
module.exports = {"form":"NewPasswordPage_form__ik2IN","passwordStrengthNote":"NewPasswordPage_passwordStrengthNote__pZqiy"};